// extracted by mini-css-extract-plugin
export default {"mainDiv":"ResetPass_mainDiv__NWcaU","logoImage":"ResetPass_logoImage__pPH20","mainLogo":"ResetPass_mainLogo__pGpc1"};